import { render, staticRenderFns } from "./product_weix_url_inner.vue?vue&type=template&id=4e18d227&scoped=true"
import script from "./product_weix_url_inner.vue?vue&type=script&lang=js"
export * from "./product_weix_url_inner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18d227",
  null
  
)

export default component.exports